import React, { useEffect } from 'react';
import {connect} from 'react-redux'
import clsx from 'clsx';

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'

import NotesTable from '../NotesTable';
import { CircularProgress, Card, CardHeader, Divider } from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: 0
  },
  content: {
    marginTop: theme.spacing(2)
  }
});

const NoteList = props => {
  const classes = useClasses(styles);

  const {
    onFetchNotes,
    onNoteRestore,
    onNoteArchive,
    onNoteAdd,
    onNoteSave,
    onNoteCancel,
    onNoteDisputeCancel,
    onNoteDisputeSave,
    onNoteChangeRequestCancel,
    onNoteChangeRequestSave,
    token,
    merchantId,
    className,
    loading,
    saving,
    notes,
    accounts,
    loading_accounts,
    highlight,
    is_dm_admin,
    ...rest
  } = props
  
  useEffect(() => {
    onFetchNotes(token, merchantId);
  }, [onFetchNotes, token, merchantId])

  const handleArchiveClick = (event, noteId) => {
    event.preventDefault();

    onNoteArchive(token, noteId)
  }

  const handleSubmitNoteClick = (event, note) => {
    event.preventDefault();

    let noteData = {
      note: {
        merchant_id: merchantId,
        category: note.category,
        proxied_creator: note.proxied_creator,
        note: note.note,
        submission_source: note.submission_source,
        broker_name: note.broker_name
      }
    }

    if (note.id){
      noteData = {
        note: {
          id: note.id,
          merchant_id: merchantId,
          category: note.category,
          proxied_creator: '',
          note: note.note,
          submission_source: note.submission_source,
          broker_name: note.broker_name
        }
      }
    }

    if (note.id){
      onNoteSave(noteData, note.id)
    } else {
      onNoteAdd(noteData)
    }
  };

  const handleCancelNoteClick = (event) => {
    event.preventDefault();
    onNoteCancel()
  };


  const handleSubmitNoteDisputeClick = (event, note) => {
    event.preventDefault();
    const form = event.currentTarget.form

    let noteData = {
      note: {
        reason: ''
      }
    }

    if (note.id){
      noteData = {
        note: {
          id: note.id,
          reason: note.reason
        }
      }
    }

    if (note.id && form.reportValidity()){
      onNoteDisputeSave(noteData, note.id)
    } else {
      return false;
    }
  };

  const handleCancelNoteDisputeClick = (event) => {
    event.preventDefault();
    onNoteDisputeCancel()
  };

  const handleCancelNoteChangeRequestClick = (event) => {
    event.preventDefault();
    onNoteChangeRequestCancel()
  };

  const handleSubmitNoteChangeRequestClick = (event, note) => {
    event.preventDefault();
    const noteData = {
      note: {
        new_category: note.new_category,
        new_note: note.new_note
      }
    }
    onNoteChangeRequestSave(noteData, note.id)
  };

  let active_notes = <CircularProgress />
  if(!loading){
    active_notes = (
      <NotesTable
        notes={notes}
        onArchiveClick={(event, noteId) => handleArchiveClick(event, noteId)}
        merchant_id={merchantId}
        onSubmitNoteClick={(event, note) => handleSubmitNoteClick(event, note)}
        onCancelNoteClick={(event) => handleCancelNoteClick(event)}
        onSubmitNoteDisputeClick={(event, note) => handleSubmitNoteDisputeClick(event, note)}
        onCancelNoteDisputeClick={(event) => handleCancelNoteDisputeClick(event)}
        onSubmitNoteChangeRequestClick={(event, note) => handleSubmitNoteChangeRequestClick(event, note)}
        onCancelNoteChangeRequestClick={(event) => handleCancelNoteChangeRequestClick(event)}
        accounts={accounts}
        is_dm_admin={is_dm_admin}
        loading_accounts={loading_accounts}
        highlight={highlight}
        saving={saving}
      />
    )
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        title="Notes"
      />
      <Divider />
      {active_notes}
    </Card>
  );
};

const mapStateToProps = state => {
  return {
    notes: state.note.notes,
    loading: state.note.loading,
    saving: state.note.saving,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchNotes: (token, merchantId) => dispatch(actions.fetchNotes(token, merchantId)),
    onNoteArchive: (token, noteId) => dispatch(actions.archiveNote(token, noteId)),
    onNoteAdd: (noteData) => dispatch(actions.addNote(noteData)),
    onNoteSave: (noteData, id) => dispatch(actions.updateNote(noteData, id)),
    onNoteCancel: () => dispatch(actions.closeNoteModal()),
    onNoteDisputeCancel: () => dispatch(actions.closeNoteDisputeModal()),
    onNoteDisputeSave: (noteData, id) => dispatch(actions.disputeNote(noteData, id)),
    onNoteChangeRequestCancel: () => dispatch(actions.closeNoteChangeRequestModal()),
    onNoteChangeRequestSave: (noteData, id) => dispatch(actions.changeRequestNote(noteData, id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(NoteList, axios))